import type {ChannelController} from '#lit/controllers/state_controller/index.js';

export enum HistoryControllerActions {
  LOCATION_CHANGED = 'history:location-changed',
}

export type HistoryControllerActionMap = {
  [HistoryControllerActions.LOCATION_CHANGED]: {
    previous: URL;
    current: URL;
  };
};

export type HistoryStateController = ChannelController<
  HistoryControllerActionMap,
  object
>;
